/* eslint-disable no-empty */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import useAPIHandler from "../../hook/use-api-handler";


const useOrgDetailsService = () => {
    const { fetchData } = useAPIHandler()
    const [orgDetails, setOrgDetails] = useState([]);
    const [allState, setAllState] = useState([]);
    const [open, setOpen] = useState(false);
    const handleClickOpen = () => setOpen(true);
    const handleCloseBasicInfo= () => setOpen(false);
    const fetchOrgDetailsData = async () => {
        try {
            const response = await fetchData({
                url: 'organization/organization-basic-information',
                method: 'GET'
            });
       
            setOrgDetails(response?.data)

        } catch (error) {
     
        }
    }

    const fetchAllState = async () => {

        try {
            const response = await fetchData({
                url: '/common/state',
                method: "GET",
            })
            if (response?.status === 'success' && Array.isArray(response?.data)) {
                const mappedData = response?.data?.map((item) => ({
                    id: item?.state_id,
                    name: item?.state_name
                }))
                setAllState(mappedData)

            }
        } catch (error) {
         
        }
    }
    useEffect(() => {
        fetchOrgDetailsData();
        fetchAllState()
    }, [])


    
    return {
        fetchOrgDetailsData,
        orgDetails,
        allState,
        handleClickOpen,
        handleCloseBasicInfo,
        open
    }
}
export default useOrgDetailsService